import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './car_series_description.css';

// check if series.descriptions.* is empty before rendering
const renderDescription = (series) => {
    if (!series || !series.descriptions) return null;
    const descriptionKeysToRender = ['SERIES', 'BADGE', 'ENGINE', 'TRANSMISSION', 'POWER', 'DRIVE', 'KERBMASS', 'RELEASE'].filter(
        (key) => series.descriptions[key] && series.descriptions[key].label && series.descriptions[key].description);
    return descriptionKeysToRender.map((key, index) => {
        const description = series.descriptions[key];
        return (
            <span key={description.label}>
                <span>
                    { index === 0 ? '' : ' | '}
                    {description.label}
                    :
                    {' '}
                </span>
                <span className={styles.bold}>{description.description}</span>
            </span>
        );
    });
};

/**
 * Render the Car Series Description component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const _CarSeriesDescription = ({ series, className = '' }) => {
    if (!series || !series.descriptions) return null;
    return (
        <div className={classNames(styles.root, className)}>
            <span className={styles.container}>
                {renderDescription(series)}
            </span>
        </div>
    );
};

_CarSeriesDescription.propTypes = {
    series: PropTypes.object.isRequired,
    className: PropTypes.string
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    const series = JSON.parse(JSON.stringify(state.getIn(['vertical', 'quote', 'apiResponses', 'series']) || []));
    const currentSeries = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'redbookCode']) || '';
    return {
        series: series.find((s) => s.redbookCode === currentSeries) || null
    };
};

const CarSeriesDescription = connect(mapStateToProps)(_CarSeriesDescription);

export { CarSeriesDescription, _CarSeriesDescription };
